<div class="actions-container">
  <ng-casto-button [label]="'need_mapping.no_choice.info'|translate" class="secondary"
                   (click)="selectLayout('')"></ng-casto-button>
</div>
<ul class="inspiration-items">
  @for (layout of datas.layouts; track layout) {
    <li [class.active]="current.kitchen.layoutRef === layout.id">
      <figure (click)="selectLayout(layout.id)">
      <span class="media padding">
        <img class="vertical" [src]="'assets/img/' + layout.img" [alt]="layout.titleRef | translate" />
        <span class="title-overlay">
   {{ layout.titleRef | translate }}
  </span>
        <span class="state">
          <svg class="icon-action-select-thumb" aria-hidden="true">
            <use
              xmlns:xlink="http://www.w3.org/1999/xlink"
              xlink:href="assets/img/icons.svg#icon-action-select-thumb"></use>
          </svg>
        </span>
      </span>
      </figure>
    </li>
  }

</ul>
<p class="disclaimer mb-5">{{ 'need_mapping.layout.disclaimer' | translate }}</p>
